import { render } from "./optionbuttonstringid.vue?vue&type=template&id=5aa3140a"
import script from "./optionbuttonstringid.vue?vue&type=script&lang=js"
export * from "./optionbuttonstringid.vue?vue&type=script&lang=js"

import "./optionbuttonstringid.vue?vue&type=style&index=0&id=5aa3140a&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__